// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"EP3f-8TAeIslVVlXLLaZo","externalId":"_3JBI6MC6blVBgB1qbkuuVz"};